// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  opId: __t.u64().primaryKey().name("op_id"),
  civ: __t.string(),
  cyc: __t.u64(),
  operation: __t.string(),
  targetSystem: __t.string().name("target_system"),
  capsReserved: __t.u32().name("caps_reserved"),
  utilityJson: __t.string().name("utility_json"),
  reason: __t.string(),
  decidedAt: __t.timestamp().name("decided_at"),
});
